import React from "react";
import config from "../config/routes";
import { Map } from "../pages/Map";
import { PlayBack } from "../pages/PlayBack";
import { Login } from "../pages/Login";
import {
  Camera,
  CameraGroup,
  AddCamera,
  AddGroup,
  EditGroup,
  WaitConfirm,
  Role,
  AddRole,
  EditRole,
  RoleCamera,
  AddRoleCompany,
  Services,
  Subscribe,
  PayService,
  CreateWareHouse,
  WareHouse,
  Companies,
  CreateCompany,
  AddUser,
  SetupDefault,
} from "../pages/Administration";
import WebRTCLiveStream from "../pages/WebRTC";
import InfoUser from "../pages/InfoUser";
import User from "../pages/Administration/User/User/User";
import Register from "../pages/Register/Register";
import RegisterVerify from "../pages/Register/RegisterVerify";
import WellcomeSucces from "../pages/Register/WellcomeSucces";
import ForgotPassword from "../pages/ForgotPassword";
import VerifyForgotPassword from "../pages/ForgotPassword/verifyForgotPassword";
import ChangePassword from "../pages/ForgotPassword/changePassword";
import WellcomeBack from "../pages/ForgotPassword/WellcomeBack";
import InfoDetail from "../pages/Administration/User/InfoDetail";
import { NotificationDetail } from "../pages/NotigicationDetail";
import { AdminNotification } from "../pages/Administration/Notification";
import { HistoryAccess, HistoryConfiguration, HistoryError, HistoryLive, HistoryRecord, HistoryUser } from "../pages/History";
import NotFound from "../pages/NotFound/NotFound";
import Assignment from "../pages/FaceDetection/Assignment/Assignment";
import ErrorPage from "../pages/ErrorPage";
import Tracing from "../pages/ManagerAI/Tracing";
import Timekeeping from "../pages/ManagerAI/Timekeeping";
import ChangeNewPass from "../pages/ChangeNewPass";
import {  ViewVideoLisencePlate } from "../pages/LisencePlate";
import ManagerLisencePlate from "../pages/LisencePlate/MangerService/ManagerLisencePlate";
import { ManagerFaceDetection, ViewVideoFaceDetection } from "../pages/FaceDetection";
// import { FaceDetection } from "../pages/SmartReport/tabBar1";
import ObjectManager from "../pages/FaceDetection/ObjectManager/ObjectManager";
import { PlaybackDesktopAppView, PlaybackDesktopAppViewOneCam } from "../pages/DesktopAppView";
// import Dashboard from "../pages/Dashboard/Dashboard";
const LiveCamera = React.lazy(() => import('../pages/LiveCamera/LiveCamera'));
const SmartReport = React.lazy(() => import('../pages/SmartReport/SmartReport'));
const Dashboard = React.lazy(() => import('../pages/Dashboard/Dashboard'));
const NotificationSetting = React.lazy(() => import('../pages/NotificationSetting/NotificationSetting'));
const Home = React.lazy(() => import('../pages/Home/Home'))
const CameraControl = React.lazy(()=>import('../pages/ManagerAI/CameraControl/CameraControl'))
const TicketManagement = React.lazy(() => import('../pages/TicketManagement/TicketManagement'));
const TicketCreate = React.lazy(() => import('../pages/TicketManagement/TicketCreate'));
const TicketUpdate = React.lazy(() => import('../pages/TicketManagement/TicketUpdate'));
const AiAlert = React.lazy(() => import('../pages/AiAlert/AiAlert'));
const publicRoutes = [
  { path: config.dashboard, component: Dashboard, layout: true },
  { path: config.liveCamera, component: LiveCamera, layout: true },
  { path: config.map, component: Map, layout: true },
  { path: config.playback, component: PlayBack, layout: true },
  {
    path: config.rtc,component:WebRTCLiveStream,layout:true
  },
  // { path: config.smartReport, component: SmartReport, layout: true },
  { path: config.login, component: Login },
  // { path: config.camera, component: Camera, layout: true },
  // { path: config.cameraGroup, component: CameraGroup, layout: true },
  // { path: config.addCamera, component: AddCamera, layout: true },
  // { path: config.editCamera, component: AddCamera, layout: true },
  // { path: config.addGroup, component: AddGroup, layout: true },
  // { path: config.editGroup, component: EditGroup, layout: true },
  { path: config.infoUser, component: InfoUser, layout: true },
  { path: config.user, component: User, layout: true },
  { path: config.register, component: Register },
  { path: config.registerVerify, component: RegisterVerify },
  { path: config.registerSucces, component: WellcomeSucces },
  { path: config.forgotPassword, component: ForgotPassword },
  { path: config.forgotPasswordVerify, component: VerifyForgotPassword },
  { path: config.changePassword, component: ChangePassword },
  { path: config.changePasswordSucces, component: WellcomeBack },
  // { path: config.waitConfirm, component: WaitConfirm, layout: true },
  // { path: config.role, component: Role, layout: true },
  // { path: config.addRoleById, component: AddRoleCompany, layout: true },
  // { path: config.editRole, component: EditRole, layout: true },
  // { path: config.addRole, component: AddRole, layout: true },
  // { path: config.roleCamera, component: RoleCamera, layout: true },
  // { path: config.wareHouse, component: WareHouse, layout: true },
  // { path: config.createWareHouse, component: CreateWareHouse, layout: true },
  // { path: config.editWareHouse, component: CreateWareHouse, layout: true },
  // { path: config.userDetail, component: InfoDetail, layout: true },
  // { path: config.services, component: Services, layout: true },
  // { path: config.subscribeService, component: Subscribe, layout: true },
  // { path: config.payService, component: PayService, layout: true },
  // { path: config.notificationDetail, component: NotificationDetail, layout: true },
  // { path: config.adminNotification, component: AdminNotification, layout: true },
  // { path: config.historyAccess, component: HistoryAccess, layout: true },
  // { path: config.historyUser, component: HistoryUser, layout: true },
  // { path: config.historyStream, component: HistoryLive, layout: true },
  // { path: config.historyRecord, component: HistoryRecord, layout: true },
  // { path: config.historyConfiguration, component: HistoryConfiguration, layout: true },
  // { path: config.historyEquipment, component: HistoryEquipment, layout: true },
  // { path: config.historyError, component: HistoryError, layout: true },
  { path: config.errorPage, component: ErrorPage, layout: true },
  { path: config.notificationSetting, component: NotificationSetting, layout: true },
  // { path: config.adminNotification, component: NotificationAdmin, layout: true },
  { path: config.eventTracing, component: Tracing, layout: true},
  // {path: config.timekeeping, component: Timekeeping, layout: true},
  { path: config.notFound, component: NotFound, layout: false},
  { path: config.companies, component: Companies, layout: true},
  // {path: config.createCompany, component: CreateCompany, layout: true},
  // {path: config.changeInfoCompany, component: CreateCompany, layout: true},
  // {path: config.addUser, component: AddUser, layout: true},
  { path: config.changeNewPass, component: ChangeNewPass, layout: false},
  { path: config.home, component: Home, layout: true},
  // {path: config.cameraControl, component:CameraControl, layout: true},
  { path: config.viewVideoLisencePlate, component: ViewVideoLisencePlate, layout: true},
  { path: config.managerLisencePlate, component: ManagerLisencePlate, layout: true},

  { path: config.viewVideoFireAlarm, component: ViewVideoFaceDetection, layout: true},
  { path: config.managerFireAlarm, component: ManagerFaceDetection, layout: true},

  { path: config.viewVideoFaceDetection, component: ViewVideoFaceDetection, layout: true},
  { path: config.managerFaceDetection, component: ManagerFaceDetection, layout: true},
  { path: config.setDefault, component: SetupDefault, layout: true},
  { path: config.assignFaceDetection, component: Assignment, layout: true},
  { path: config.objectManager, component: ObjectManager, layout: true},
  { path: config.playbackDesktopView, component: PlaybackDesktopAppView, layout: false},
  { path: config.playbackDesktopViewOneCam, component: PlaybackDesktopAppViewOneCam, layout: false},
  { path: config.ticketManagement, component: TicketManagement, layout: true },
  { path: config.ticketCreate, component: TicketCreate, layout: true },
  { path: config.ticketUpdate, component: TicketUpdate, layout: true },
  { path: config.aiAlert, component: AiAlert, layout: true },
];
export { publicRoutes };
